// relative
import { apiSlice } from '../../apiSlice';

export const accountApiSlice = apiSlice.injectEndpoints({
  tagTypes: ['Account'],
  endpoints: (builder) => ({
    getAccounts: builder.query({
      query: () => `/Accounts?orderby=AccountId&top=10000`,
      providesTags: ['Account'],
    }),
    getAccountById: builder.query({
      query: (args) => {
        const accountId = args;
        return {
          url: `/Accounts/${accountId}`,
        };
      },
      providesTags: ['Account'],
    }),
    createAccount: builder.mutation({
      query: (account) => ({
        url: `/Accounts`,
        method: 'POST',
        body: account,
      }),
      invalidatesTags: ['Account'],
      transformResponse: (response, meta) =>
        meta.response.headers.get('Location').split('/').pop(),
    }),
    removeUserRoleFromAccount: builder.mutation({
      query: ({ accountId, email, role }) => ({
        url: `/Accounts/${accountId}/Users/${email}/${role}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Account'],
    }),
    grantUserRoleToAccount: builder.mutation({
      query: ({ accountId, email, role }) => ({
        url: `/Accounts/${accountId}/Users`,
        method: 'PUT',
        body: { email, role },
      }),
      invalidatesTags: ['Account'],
    }),
    updateAccount: builder.mutation({
      query: ({ accountId, ...patch }) => ({
        url: `/Accounts/${accountId}`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: ['Account'],
    }),
    addServiceToAccount: builder.mutation({
      query: ({ accountId, serviceId }) => ({
        url: `/Accounts/${accountId}/Service/${serviceId}`,
        method: 'PUT',
      }),
      invalidatesTags: ['Account'],
    }),
    removeServiceFromAccount: builder.mutation({
      query: ({ accountId, serviceId }) => ({
        url: `/Accounts/${accountId}/Service/${serviceId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Account'],
    }),
  }),
});

export const {
  useGetAccountsQuery,
  useGetAccountByIdQuery,
  useLazyGetAccountByIdQuery,
  useAddServiceToAccountMutation,
  useRemoveServiceFromAccountMutation,
  useCreateAccountMutation,
  useUpdateAccountMutation,
  useRemoveUserRoleFromAccountMutation,
  useGrantUserRoleToAccountMutation,
} = accountApiSlice;
